import React from 'react';
import { Target, Eye, Award } from 'lucide-react';
import { Card } from './ui/card';

const Mission = () => {
  return (
    <section id="mision" className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sky-600 font-semibold text-sm uppercase tracking-wide mb-2 block">
            Nuestra Razón de Ser
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Misión y Visión
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Creemos en el potencial de cada joven deportista del interior argentino
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {/* Mission Card */}
          <Card className="p-8 border-2 border-gray-100 hover:border-sky-400 hover:shadow-2xl transition-all duration-300 group">
            <div className="w-16 h-16 bg-gradient-to-br from-sky-400 to-sky-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Target className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Misión</h3>
            <p className="text-gray-600 leading-relaxed">
              Brindar oportunidades de desarrollo deportivo profesional a jóvenes talentosos del interior de
              Argentina, eliminando las barreras económicas y geográficas que limitan su potencial.
            </p>
          </Card>

          {/* Vision Card */}
          <Card className="p-8 border-2 border-gray-100 hover:border-sky-400 hover:shadow-2xl transition-all duration-300 group">
            <div className="w-16 h-16 bg-gradient-to-br from-sky-500 to-sky-700 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Eye className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Visión</h3>
            <p className="text-gray-600 leading-relaxed">
              Ser la fundación líder en Argentina en el descubrimiento y formación de atletas de elite,
              reconocida por transformar vidas y fortalecer el deporte nacional.
            </p>
          </Card>

          {/* Values Card */}
          <Card className="p-8 border-2 border-gray-100 hover:border-sky-400 hover:shadow-2xl transition-all duration-300 group">
            <div className="w-16 h-16 bg-gradient-to-br from-sky-600 to-sky-800 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
              <Award className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Valores</h3>
            <p className="text-gray-600 leading-relaxed">
              Compromiso, excelencia, inclusión y transparencia guían cada una de nuestras acciones para
              asegurar el máximo impacto en la vida de nuestros atletas.
            </p>
          </Card>
        </div>

        {/* Additional Info */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-sky-50 to-blue-50 rounded-2xl p-8 sm:p-12 border border-sky-100">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
              El Talento Está en Todo el País
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              En el interior de Argentina existe un enorme potencial deportivo sin explotar. Muchos jóvenes con
              talento excepcional no pueden acceder a entrenamientos de calidad, infraestructura adecuada o
              competencias de nivel debido a limitaciones económicas. <span className="font-semibold text-sky-700">Nuestra fundación
              cierra esa brecha</span>, conectando a estos atletas con las oportunidades que merecen.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
